"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepCompanySubscriptions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const elements_1 = require("@src/components/elements");
const StepCompanySubscriptions_style_1 = require("./StepCompanySubscriptions.style");
const CompanyCard_1 = require("./CompanyCard");
const StepCompanySubscriptions = react_1.default.forwardRef(({ setIsLoading }, ref) => {
    const [companies, setCompanies] = react_1.default.useState([]);
    const [selectedCompanyIds, setSelectedCompanyIds] = react_1.default.useState([]);
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const showErrorNotification = () => {
        antd_1.notification.error({
            message: intl.formatMessage({ id: 'onboarding.error.title' }),
            description: intl.formatMessage({ id: 'onboarding.error.description' }),
        });
    };
    const initialize = async () => {
        try {
            const fetchedCompanies = await Api.Company.fetchCompanyCandidatesForSubscription();
            setCompanies(fetchedCompanies);
            setIsInitialized(true);
        }
        catch (_a) {
            showErrorNotification();
        }
    };
    react_1.default.useEffect(() => {
        initialize();
    }, []);
    const saveCompanySubscriptions = async () => {
        setIsLoading(true);
        try {
            await Api.Company.subscribeToCompanies(selectedCompanyIds);
        }
        catch (_a) {
            showErrorNotification();
        }
        finally {
            setIsLoading(false);
        }
    };
    react_1.default.useImperativeHandle(ref, () => ({ saveCompanySubscriptions }));
    const isCompanySelected = (companyId) => selectedCompanyIds.includes(companyId);
    const toggleCompanySelect = (companyId) => {
        if (isCompanySelected(companyId)) {
            setSelectedCompanyIds(selectedCompanyIds.filter(id => id !== companyId));
        }
        else {
            setSelectedCompanyIds([...selectedCompanyIds, companyId]);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(StepCompanySubscriptions_style_1.CompanySubscriptionsStepWrapper, { children: [(0, jsx_runtime_1.jsx)(StepCompanySubscriptions_style_1.TextWrapper, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "onboarding.company_subscriptions.text" }) }), !isInitialized && ((0, jsx_runtime_1.jsx)(StepCompanySubscriptions_style_1.SpinnerWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Spinner, {}) })), isInitialized && ((0, jsx_runtime_1.jsx)(StepCompanySubscriptions_style_1.CompanyCardsWrapper, { children: (0, jsx_runtime_1.jsx)(StepCompanySubscriptions_style_1.StyledRow, { justify: "center", gutter: [16, 16], children: companies.map(company => ((0, jsx_runtime_1.jsx)(antd_1.Col, { children: (0, jsx_runtime_1.jsx)(CompanyCard_1.CompanyCard, { company: company, isSelected: isCompanySelected(company.id), onClick: () => toggleCompanySelect(company.id) }) }, company.id))) }) }))] }));
});
exports.StepCompanySubscriptions = StepCompanySubscriptions;
